import { IField } from "../interfaces/inputs/IField";
import { Endpoints } from "../utils/Endpoints";
import { getForms } from "../utils/Helpers";

const genders = [
  {value: 'F', text: 'Female'},
  {value: 'M', text: 'Male'}
]

const statuses = [
  {value: 'active', text: 'Active'},
  {value: 'inactive', text: 'Inactive'}
]

const forms = getForms();

export const InterviewFields: IField[] = [
  { name: "interview_date", type: "text", label: "Date", size: {lg: 6}, position: 1 },
  { name: "collection_date", type: "text", label: "Collection Date", size: {lg: 6}, position: 2 },
  { name: "interview_fee", type: "text", label: "Interview Fee", size: {lg: 6}, position: 3 },
  { name: "headteacher_name", type: "text", label: "Head teacher's name", size: {lg: 6}, position: 4 },
  { name: "headteacher_title", type: "text", label: "Head teacher's title", size: {lg: 6}, position: 5 },
  { name: "payment_deadline", type: "text", label: "Payment Deadline", size: {lg: 6}, position: 6 },
].sort((a: IField, b: IField) => a.position - b.position);